<div class="body-container">
    <app-header></app-header>
    <router-outlet></router-outlet>
</div>
